module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/active-tool/carussel/carussel.component.html
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/active-tool/carussel/carussel.component.html
// module chunks = main